import { render, staticRenderFns } from "./IpfTableForPayment.vue?vue&type=template&id=e9957636&scoped=true&"
import script from "./IpfTableForPayment.vue?vue&type=script&lang=ts&"
export * from "./IpfTableForPayment.vue?vue&type=script&lang=ts&"
import style0 from "./IpfTableForPayment.vue?vue&type=style&index=0&id=e9957636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9957636",
  null
  
)

export default component.exports